import tippy, {createSingleton} from 'tippy.js';
import { updateLazy } from '../common/lazy'

export const initTippy = (selector = '.js-tippy', options = {}) => {
    const offsetTop = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) + 20
    let combinedOptions = null

    for (const el of [...document.querySelectorAll(selector)].filter(el => !el._tippy)) {
        combinedOptions = {...{
            content: el.dataset.tippyContent,
            animation: 'shift-away',
            theme: 'general',
            placement: 'top-start',
            allowHTML: true,
            interactive: true,
            zIndex: 99,
            interactiveBorder: 24,
            delay: [null, 200],
            maxWidth: 420,
            appendTo: () => document.body,
            popperOptions: {
                modifiers: [
                    {
                        name: 'flip',
                        options: {
                            fallbackPlacements: ['top-end', 'bottom-end', 'bottom-start'],
                            padding: {
                                top: offsetTop,
                                right: 10,
                                bottom: 10,
                                left: 10
                            }
                        },
                    },
                ],
            },
        }, ...options}

        tippy(el, combinedOptions)
    }

    for (const holder of [...document.querySelectorAll('.js-singleton-holder')].filter(el => !el.classList.contains('is-singleton-initialized'))) {
        const singletonInstances = []

        for (const el of holder.querySelectorAll(selector)) {
            if (el._tippy) {
                singletonInstances.push(el._tippy)
            }
        }

        if (singletonInstances.length) {
            createSingleton(singletonInstances, {
                delay: [200, 0],
                overrides: Object.keys(combinedOptions)
            })
        }

        holder.classList.add('is-singleton-initialized')
    }
}

export const tippyAlert = (targetEl, message, tippyOptions = {}, delay = 4000) => {
    if (!targetEl) {
        return
    }

    const instance = tippy(targetEl, {
        content: message,
        animation: 'shift-away',
        theme: 'success',
        placement: 'bottom',
        allowHTML: true,
        trigger: 'manual',
        appendTo: () => document.body,
        ...tippyOptions
    })

    instance.show()

    setTimeout(() => {
        instance.hide()
        setTimeout(() => {
            instance.destroy()
        }, 300)
    }, delay)
}